import { useEffect } from 'react';
import ButtonLoginGoogle from '../../Buttons/ButtonLoginGoogle';
import ButtonLoginX from '../../Buttons/ButtonLoginX';
import "./ThirdPartyProviders.linaria.module.css!=!./ThirdPartyProviders?./ThirdPartyProviders.linaria.module.css?css=H4sIAAAAAAAAA12Oyw6CMBRE9/yHSwglxsTyMU0tV3qxD6QXKDb8u2EBBpcnZ2YyhSQr7kEwijNOJjUYeiMX/jQQ6zUrNj0tgvnw9tWUZmxIc1aWl11CdUgN2Go6WVwEq2IcH12yMua/RH+sa8H0zXfj50xJGmxdjgQ2cAWOYNgbchDs0V/9S/1h2l7nDQ6gCL3jypvRunrNvjChJG/mAAAA"
const rootStyles = "atm_9s_1txwivl atm_vy_1osqo2v atm_e2_1osqo2v atm_iy_12xxubj atm_h_1h6ojuz atm_ar_1bp4okc";
interface ThirdPartyProviderProps {
  embedded?: boolean;
  signup?: boolean;
}
const ThirdPartyProviders = ({
  embedded,
  signup
}: ThirdPartyProviderProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section style={embedded ? {
    maxHeight: 84
  } : {}} data-testid="Authentication__ThirdPartyProviders" className={rootStyles}>
            <ButtonLoginGoogle embedded={embedded} signup={signup} />
            <ButtonLoginX embedded={embedded} signup={signup} />
        </section>;
};
export default ThirdPartyProviders;